export const isNpmPackage = false;